import BottomMobileOptionsModal from "@/components/bottom-mobile-options-modal";
import { Button } from "@/components/ui/button";
import type { Dialog } from "@/components/ui/dialog";
import type { UserType } from "@/components/user-search-modal/types";
import type { EscapeType } from "@/graphql/queries/use-verify-user-escape-tag";

interface JoinModalProps extends React.ComponentProps<typeof Dialog> {
  escape: EscapeType;
  onContinue(escapeId: string): void;
  user: UserType;
}

export default function JoinModal({
  escape: escapeObj,
  onContinue,
  user,
  ...props
}: JoinModalProps) {
  const handleContinue = () => onContinue(escapeObj.id);

  return (
    <BottomMobileOptionsModal
      isCloseable={false}
      title={`Join ${user.username}?`}
      {...props}
    >
      <p className="text-center text-14/[1.5em] text-pale-lavender">
        {user.username} has already marked {escapeObj.game?.name} as done. Do
        you want to join their experience?
      </p>
      <p className="mt-5 text-center text-14/[1.5em] text-pale-lavender">
        Some details you&apos;ve entered for {escapeObj.game?.name} may be
        overwritten.
      </p>
      <div className="grid grid-cols-2 gap-4 py-6">
        <Button
          className="h-[45px] rounded-[23px]"
          onClick={handleContinue}
          variant="cta"
        >
          Continue
        </Button>
        <Button
          className="h-[45px] rounded-[23px] border border-white/50 font-medium text-13 text-white"
          onClick={() => props.onOpenChange?.(false)}
        >
          Cancel
        </Button>
      </div>
    </BottomMobileOptionsModal>
  );
}
